import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { useGetBatchCollectionsFromState } from '../../containers/batches/get-batch-collections-from-state';
import { BatchDropdownItem } from './batch-dropdown-menu-item';

import messages from './messages';
import style from './add-to-batch-dropdown.module.less';

export const version1 = 'version1';
export const version2 = 'version2';

const calculateIsCurrent = (fulfillmentPlanSetId, activeFulfillmentPlanSetId) => {
  return fulfillmentPlanSetId === activeFulfillmentPlanSetId;
};

export const AddToBatchDropdownItems = ({
  addIdsToBatch,
  createBatchWithIds,
  shouldShowLoadMoreButton = false,
  loadMore,
  activeFulfillmentPlanSetId,
  version = version1,
}) => {
  const { myBatches, otherBatches } = useGetBatchCollectionsFromState();
  const loadMoreBatches = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    loadMore();
  };

  return (
    <div className={style[version]}>
      <DropdownMenuItem onClick={createBatchWithIds}>
        <FormattedMessage {...messages.createNewBatch} />
      </DropdownMenuItem>
      {myBatches.length > 0 && (
        <div>
          <div className={style['dropdown-section-header']}>
            <FormattedMessage {...messages.addToMyExistingBatch} />
          </div>
          {myBatches.map(({ name, fulfillmentPlanSetId, shipmentCount }) => {
            const isCurrent = calculateIsCurrent(fulfillmentPlanSetId, activeFulfillmentPlanSetId);
            return (
              <BatchDropdownItem
                key={fulfillmentPlanSetId}
                className={style['order-details-add-to-batch-dropdown-item']}
                disabled={isCurrent}
                fulfillmentPlanSetId={fulfillmentPlanSetId}
                name={name}
                onClick={() => {
                  addIdsToBatch(fulfillmentPlanSetId, name);
                }}
                shipmentCount={shipmentCount}
                title={name}
              />
            );
          })}
        </div>
      )}
      {otherBatches.length > 0 && (
        <div>
          <div className={style['dropdown-section-header']}>
            <FormattedMessage {...messages.addToOtherExistingBatch} />
          </div>
          {otherBatches.map(({ name, fulfillmentPlanSetId, shipmentCount }) => {
            const isCurrent = calculateIsCurrent(fulfillmentPlanSetId, activeFulfillmentPlanSetId);
            return (
              <BatchDropdownItem
                key={fulfillmentPlanSetId}
                className={style['order-details-add-to-batch-dropdown-item']}
                disabled={isCurrent}
                fulfillmentPlanSetId={fulfillmentPlanSetId}
                name={name}
                onClick={() => {
                  addIdsToBatch(fulfillmentPlanSetId, name);
                }}
                shipmentCount={shipmentCount}
                title={name}
              />
            );
          })}
        </div>
      )}
      {shouldShowLoadMoreButton && (
        <div className={style['load-more-button']}>
          <Button onClick={loadMoreBatches} theme='link'>
            <FormattedMessage {...messages.loadMoreBatches} />
          </Button>
        </div>
      )}
    </div>
  );
};

AddToBatchDropdownItems.propTypes = {
  addIdsToBatch: PropTypes.func.isRequired,
  createBatchWithIds: PropTypes.func.isRequired,
  shouldShowLoadMoreButton: PropTypes.bool,
  loadMore: PropTypes.func.isRequired,
  activeFulfillmentPlanSetId: PropTypes.string,
  version: PropTypes.string,
};
